const STYLES = {
  approved: "border-emerald-500/50 text-emerald-300",
  rejected: "border-red-500/50 text-red-300",
  pending: "border-amber-500/50 text-amber-300",
};

export const KycBadge = ({ status = "pending" }) => (
  <span data-testid="kyc-status-badge" className={`inline-block whitespace-nowrap border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${STYLES[status] || STYLES.pending}`}>
    {status}
  </span>
);
